webpackJsonp([35783957827783],{

/***/ 403:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 264:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(18);
	
	__webpack_require__(403);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RedButtonLG = function RedButtonLG(props) {
	    return _react2.default.createElement(
	        'button',
	        {
	            className: 'RedButtonLG',
	            role: 'button',
	            onClick: function onClick() {
	                return (0, _gatsbyLink.navigateTo)(props.path);
	            }
	        },
	        props.children
	    );
	};
	
	exports.default = RedButtonLG;
	module.exports = exports['default'];

/***/ }),

/***/ 404:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 265:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(18);
	
	__webpack_require__(404);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var YellowButtonLG = function YellowButtonLG(props) {
	    return _react2.default.createElement(
	        'button',
	        {
	            className: 'YellowButtonLG',
	            role: 'button',
	            onClick: function onClick() {
	                return (0, _gatsbyLink.navigateTo)(props.path);
	            }
	        },
	        props.children
	    );
	};
	
	exports.default = YellowButtonLG;
	module.exports = exports['default'];

/***/ }),

/***/ 407:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 267:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(18);
	
	var _YellowButtonMD = __webpack_require__(40);
	
	var _YellowButtonMD2 = _interopRequireDefault(_YellowButtonMD);
	
	__webpack_require__(407);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ClassPreview = function ClassPreview(props) {
	    var classImage = function classImage(image) {
	        backgroundImage: image;
	    };
	    return _react2.default.createElement(
	        'div',
	        { key: props.id, className: 'ClassPreview', onClick: function onClick() {
	                return (0, _gatsbyLink.navigateTo)(props.path);
	            } },
	        _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12' },
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-6' },
	                    _react2.default.createElement('img', { src: props.image, className: 'ClassPreview-Img' })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-sm-6' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'ClassPreview-Content' },
	                        _react2.default.createElement(
	                            'h2',
	                            { className: 'ClassPreview-Title' },
	                            props.title
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            { className: 'ClassPreview-Desc' },
	                            props.children.substring(0, 280),
	                            '...'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { style: { padding: "10px 0" } },
	                            _react2.default.createElement(
	                                _YellowButtonMD2.default,
	                                { path: props.path },
	                                'View Details \xBB'
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = ClassPreview;
	module.exports = exports['default'];

/***/ }),

/***/ 409:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 270:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(18);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _YellowButtonMD = __webpack_require__(40);
	
	var _YellowButtonMD2 = _interopRequireDefault(_YellowButtonMD);
	
	__webpack_require__(409);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NewsPreview = function NewsPreview(props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'col-md-3 news-card', key: props.id, onClick: function onClick() {
	                return (0, _gatsbyLink.navigateTo)(props.path);
	            } },
	        _react2.default.createElement(
	            'small',
	            { className: 'NewsPreview-Date' },
	            props.date
	        ),
	        _react2.default.createElement(
	            'h2',
	            { className: 'news-card-title' },
	            _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: props.path },
	                props.desc
	            )
	        ),
	        _react2.default.createElement(
	            'h3',
	            { className: 'news-card-desc' },
	            props.title
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            'by: ',
	            props.author
	        ),
	        _react2.default.createElement(
	            'p',
	            { className: 'news-card-content' },
	            props.children
	        ),
	        _react2.default.createElement(
	            'p',
	            { className: 'NewsPreview-Button' },
	            _react2.default.createElement(
	                _YellowButtonMD2.default,
	                { path: props.path },
	                'View Details \xBB'
	            )
	        )
	    );
	};
	
	exports.default = NewsPreview;
	module.exports = exports['default'];

/***/ }),

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(18);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var races = function races(props) {
	    var link = "/races/" + props.page;
	    return _react2.default.createElement(
	        'div',
	        { className: 'col-lg-4' },
	        _react2.default.createElement(
	            'div',
	            { className: 'card' },
	            _react2.default.createElement('img', { src: props.image, className: 'card-img-top' }),
	            _react2.default.createElement(
	                'div',
	                { className: 'card-content' },
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'card-title' },
	                    props.raceName
	                ),
	                _react2.default.createElement(
	                    'p',
	                    { className: 'card-text' },
	                    props.children
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'card-btn' },
	                    _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { to: link, className: 'btn btn-primary' },
	                        'View Details \xBB'
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = races;
	module.exports = exports['default'];

/***/ }),

/***/ 1017:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mages.ff64e0f5.jpg";

/***/ }),

/***/ 1018:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mystic.e3f2d7cf.jpg";

/***/ }),

/***/ 1023:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ranger.0b94e104.jpg";

/***/ }),

/***/ 1026:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/warrior.91fde132.jpg";

/***/ }),

/***/ 288:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(18);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _warrior = __webpack_require__(1026);
	
	var _warrior2 = _interopRequireDefault(_warrior);
	
	var _ranger = __webpack_require__(1023);
	
	var _ranger2 = _interopRequireDefault(_ranger);
	
	var _mystic = __webpack_require__(1018);
	
	var _mystic2 = _interopRequireDefault(_mystic);
	
	var _mages = __webpack_require__(1017);
	
	var _mages2 = _interopRequireDefault(_mages);
	
	var _races = __webpack_require__(272);
	
	var _races2 = _interopRequireDefault(_races);
	
	var _YellowButtonLG = __webpack_require__(265);
	
	var _YellowButtonLG2 = _interopRequireDefault(_YellowButtonLG);
	
	var _RedButtonLG = __webpack_require__(264);
	
	var _RedButtonLG2 = _interopRequireDefault(_RedButtonLG);
	
	var _NewsPreview = __webpack_require__(270);
	
	var _NewsPreview2 = _interopRequireDefault(_NewsPreview);
	
	var _ClassPreview = __webpack_require__(267);
	
	var _ClassPreview2 = _interopRequireDefault(_ClassPreview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var data = _ref.data;
	    return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	            "div",
	            { className: "jumbotron" },
	            _react2.default.createElement(
	                "div",
	                { className: "container" },
	                _react2.default.createElement(
	                    "h1",
	                    null,
	                    "Welcome to Return of the Shadow!"
	                ),
	                _react2.default.createElement(
	                    "p",
	                    null,
	                    "Return of the Shadow is a game based on the Fourth Age of Arda, J.R.R. Tolkien's wonderful world of fantasy. Game play takes place after the destruction of the One Ring. After Sauron's fall, a period of peace was laid about the land, and the Elves, Humans, Dwarves, and Hobbits prospered."
	                ),
	                _react2.default.createElement(
	                    _YellowButtonLG2.default,
	                    { path: "/getting-started" },
	                    "Getting Started \xBB"
	                ),
	                " ",
	                _react2.default.createElement(
	                    _RedButtonLG2.default,
	                    { path: "/connect" },
	                    "Start Playing \xBB"
	                )
	            )
	        ),
	        _react2.default.createElement(
	            "section",
	            { className: "news-section" },
	            _react2.default.createElement(
	                "div",
	                { className: "container-fluid" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                        "h3",
	                        { className: "news-title" },
	                        "LATEST NEWS & UPDATES ",
	                        _react2.default.createElement(
	                            _gatsbyLink2.default,
	                            { to: "/news" },
	                            "View all news \xBB"
	                        )
	                    )
	                ),
	                data.allMarkdownRemark.edges.map(function (_ref2) {
	                    var node = _ref2.node;
	                    return _react2.default.createElement(
	                        _NewsPreview2.default,
	                        {
	                            key: node.id,
	                            title: node.frontmatter.title,
	                            date: node.frontmatter.date,
	                            path: node.frontmatter.path,
	                            desc: node.frontmatter.desc,
	                            author: node.frontmatter.author
	                        },
	                        node.excerpt
	                    );
	                })
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: "jumbotron races" },
	            _react2.default.createElement(
	                "div",
	                { className: "container" },
	                _react2.default.createElement(
	                    "h1",
	                    { className: "text-right" },
	                    "Playable Races"
	                ),
	                _react2.default.createElement(
	                    "p",
	                    { className: "races-p" },
	                    "Whether as a stalwart defender of Vinyanost, or a fierce guardian of Dol-Guldur, deciding which race to play will define who you'll fight for in this neverending war."
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "race-btn" },
	                    _react2.default.createElement(
	                        _YellowButtonLG2.default,
	                        { path: "/races" },
	                        "LEARN MORE"
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            "section",
	            { className: "classes" },
	            _react2.default.createElement(
	                "div",
	                { className: "container-fluid" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "row" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "col-lg-12" },
	                        _react2.default.createElement(
	                            "h3",
	                            { className: "news-title" },
	                            "PLAYABLE CLASSES ",
	                            _react2.default.createElement(
	                                _gatsbyLink2.default,
	                                { to: "/classes" },
	                                "View all classes \xBB"
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "col-lg-12" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "row" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "col-lg-6" },
	                                _react2.default.createElement(
	                                    _ClassPreview2.default,
	                                    {
	                                        path: "/classes/warrior/",
	                                        title: "Warrior",
	                                        image: _warrior2.default },
	                                    "Warriors are very proficient in raw fighting skill, and are generally well trained in their knowledge of the wilderness.  However, they are rather mediocre in their talent as a cleric and only partially tuned to the spirit world.  Their knowledge of magery is generally lacking."
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: "col-lg-6" },
	                                _react2.default.createElement(
	                                    _ClassPreview2.default,
	                                    {
	                                        path: "/classes/ranger/",
	                                        title: "Ranger",
	                                        image: _ranger2.default },
	                                    "Rangers are the masters of stealth and wilderness: they are well trained in the handling of animals, herblores and tracking.  Rangers do not tend to be accustomed to the aggressive style of fighting that marks a seasoned warrior; instead they depend on their nimble movements and quick reflexes for a defensive style of combat.  The average ranger's understanding of magical arts is only mediocre; but rangers, being attuned to natural environs, are completely uncomfortable with clerical duties and the world of wraiths."
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "row" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "col-lg-6" },
	                                _react2.default.createElement(
	                                    _ClassPreview2.default,
	                                    {
	                                        path: "/classes/mystic",
	                                        title: "Mystic",
	                                        image: _mystic2.default },
	                                    "Mystics are rare in Arda; while most of Arda's inhabitants avoid wraiths and their kin at all costs, these daring souls have heightened their perception of the spiritual world in hopes of coming in contact with its undead inhabitants.  However, the common mystic does not narrow its scope of study to the clerical arts: most mystics are able to employ the arts of magery with decent success.  But as a consequence of this rigorous mental training, mystics are left with very little training as a fighter, and with a dismal knowledge of wilderness the outdoors."
	                                )
	                            ),
	                            _react2.default.createElement(
	                                "div",
	                                { className: "col-lg-6" },
	                                _react2.default.createElement(
	                                    _ClassPreview2.default,
	                                    {
	                                        path: "/classes/mage",
	                                        title: "Mage",
	                                        image: _mages2.default },
	                                    "Mages are experts of those magical arts which emtail the manipulation of the physical world: fire, lightning, ice and darkness.  In general, mages make heavy use of their spells to cause as much physical harm to their victim as possible.  However, the arts of magery also include control of the physical body and scrying magics: teleportation and informative spells. Mages generally receive a decent training in the aspects of the Wraith world, and commonly find themselves knowledgeable enough in the arts of animals and wilderness.  However, as mages spend most of their time enthralled in intellectual pursuit, they neglect their physical bodies and their ability to fight."
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-f92ad86f479e282c59bb.js